module.exports = __webpack_public_path__ + "static/media/romulo-leitao.99e669b7.webp";